
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, class_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { map as map_1, toArray as toArray_1, length, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import React from "react";
import { reactApi as reactApi_1, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import react_joyride from "react-joyride";

export class TourStep extends Record {
    constructor(Target, Title, Content, Placement, DisableScrollParentFix) {
        super();
        this.Target = Target;
        this.Title = Title;
        this.Content = Content;
        this.Placement = Placement;
        this.DisableScrollParentFix = DisableScrollParentFix;
    }
}

export function TourStep_$reflection() {
    return record_type("Components.TourGuide.TourStep", [], TourStep, () => [["Target", string_type], ["Title", option_type(string_type)], ["Content", class_type("Fable.React.ReactElement")], ["Placement", string_type], ["DisableScrollParentFix", bool_type]]);
}

export class TourGuideLocale extends Record {
    constructor(Back, Close, Last, Next, NextLabelWithProgress, Open, Skip) {
        super();
        this.Back = Back;
        this.Close = Close;
        this.Last = Last;
        this.Next = Next;
        this.NextLabelWithProgress = NextLabelWithProgress;
        this.Open = Open;
        this.Skip = Skip;
    }
}

export function TourGuideLocale_$reflection() {
    return record_type("Components.TourGuide.TourGuideLocale", [], TourGuideLocale, () => [["Back", string_type], ["Close", string_type], ["Last", string_type], ["Next", string_type], ["NextLabelWithProgress", string_type], ["Open", string_type], ["Skip", string_type]]);
}

function joyrideLocaleToJs(l) {
    return {
        back: l.Back,
        close: l.Close,
        last: l.Last,
        next: l.Next,
        nextLabelWithProgress: l.NextLabelWithProgress,
        open: l.Open,
        skip: l.Skip,
    };
}

const primary = "#14BC9C";

const ink = "#14181B";

const muted = "#717171";

const border = "#E1E7F0";

const secondaryBorder = "#B6BECB";

const joyrideThemeStyles = {
    options: {
        primaryColor: primary,
        backgroundColor: "#FFFFFF",
        textColor: ink,
        arrowColor: "#FFFFFF",
        overlayColor: "rgba(20, 24, 27, 0.52)",
        width: 300,
        zIndex: 10050,
        spotlightShadow: "0 0 0 2px rgba(20, 188, 156, 0.95), 0 8px 28px rgba(20, 188, 156, 0.22)",
    },
    tooltip: {
        borderRadius: 10,
        padding: 0,
        fontSize: 14,
        boxShadow: "0 12px 40px rgba(15, 24, 27, 0.14)",
        fontFamily: "\'Inter\', system-ui, -apple-system, sans-serif",
    },
    tooltipContainer: {
        textAlign: "left",
        lineHeight: 1.45,
    },
    tooltipTitle: {
        fontSize: 15,
        fontWeight: 600,
        color: ink,
        margin: 0,
        padding: "14px 18px 0 18px",
    },
    tooltipContent: {
        padding: "6px 18px 14px 18px",
        fontSize: 14,
        color: muted,
    },
    tooltipFooter: {
        marginTop: 0,
        padding: "10px 14px 12px 14px",
        borderTop: concat("1px solid ", ...border),
        justifyContent: "flex-end",
        alignItems: "center",
    },
    buttonNext: {
        backgroundColor: primary,
        color: "#FFFFFF",
        borderRadius: 8,
        fontSize: 14,
        fontWeight: 600,
        padding: "10px 16px",
        border: 0,
        lineHeight: 1.2,
        cursor: "pointer",
        minHeight: 40,
        WebkitAppearance: "none",
    },
    buttonBack: {
        backgroundColor: "transparent",
        color: primary,
        borderRadius: 8,
        fontSize: 14,
        fontWeight: 600,
        padding: "10px 14px",
        border: concat("1px solid ", ...secondaryBorder),
        lineHeight: 1.2,
        cursor: "pointer",
        WebkitAppearance: "none",
    },
    buttonSkip: {
        color: muted,
        fontSize: 14,
        fontWeight: 500,
        padding: "10px 10px",
        cursor: "pointer",
        border: 0,
        backgroundColor: "transparent",
        lineHeight: 1.2,
    },
    buttonClose: {
        color: muted,
        padding: 12,
        cursor: "pointer",
        border: 0,
        backgroundColor: "transparent",
    },
    spotlight: {
        borderRadius: 10,
    },
};

function buildStep(step) {
    return toList(delay(() => append(singleton(["target", step.Target]), delay(() => append(singleton(["content", step.Content]), delay(() => append(singleton(["placement", step.Placement]), delay(() => append(singleton(["disableScrollParentFix", step.DisableScrollParentFix]), delay(() => append(singleton(["disableBeacon", true]), delay(() => append(singleton(["spotlightPadding", 8]), delay(() => ofArray(toArray(map((value_6) => ["title", value_6], step.Title)))))))))))))))));
}

export function TourGuide(props) {
    let elems, props_1;
    const showProgress = length(props.Steps) > 1;
    const enableScroll = (length(props.Steps) > 1) ? true : props.ScrollFirstStep;
    return reactElement("div", createObj(ofArray([["className", "fixed left-0 top-0 m-0 h-0 w-0 overflow-visible border-0 p-0"], (elems = [(props_1 = ofArray([["run", props.IsRunning], ["steps", toArray_1(map_1(createObj, map_1(buildStep, props.Steps)))], ["continuous", true], ["showProgress", showProgress], ["showSkipButton", true], ["spotlightClicks", true], ["scrollToFirstStep", enableScroll], ["disableScrolling", !enableScroll], ["disableCloseOnEsc", true], ["disableOverlayClose", true], ["hideBackButton", length(props.Steps) < 2], ["styles", joyrideThemeStyles], ["locale", joyrideLocaleToJs(props.Locale)], ["callback", (data) => {
        if (data.status === "finished") {
            if (data.action === "skip") {
                props.OnSkip();
            }
            else {
                props.OnFinish();
            }
        }
    }]]), reactApi.createElement(react_joyride, createObj(props_1)))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

